import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userSession = sessionStorage.getItem("user") || "";
  if (userSession) {

    const user = JSON.parse(userSession);
    if (!user.token) {
      router.navigate(['/login']);
      return false;
    }
  }
  return true;
};
